import { Fancybox } from '@fancyapps/ui'; // eslint-disable-line

export default ($) => {
    var _filterTrigger = document.getElementById('trigger-filter');

    if (!_filterTrigger)
        return;

    var _search        = document.getElementById('pf-search-field');
    var _availability  = $('.js-availability');
    var _results       = $('#results');
    var _cards         = $('.js-pf-card');
    var _cardsResults  = $('.js-pf-result');
    var _windowWidth   = 0;
    var _orderCount    = calculateTotalOrder();
    var _choices       = [];
    var iWantTrigger   = $('#i-want-trigger');
    var iWantTriggerSl = '#i-want-trigger';
    var programType    = $('select[name=program-type]');
    var location       = $('select[name=location]');
    var _fancybox;

    var _foundResult   = 0;
    var _foundCount    = 1;

    if (_search)
        searchFilter();

    closeCardResult();
    iWantTo();
    chkAvailability();
    selectFilter(programType);
    selectFilter(location);
    initCountTest();

    _cards.on('click', function () {
        var _this       = $(this);
        var _cardOrder  = parseInt(_this.css('order'));
        var _cardResult = _this.next('.js-pf-result');
        var _cardImg    = _cardResult.find('.js-card-img');
        var _cardImgUrl = _cardImg.data('img');

        closeAllResults();
        _cardResult.addClass('active').css('order', calculateResultOrder(_cardOrder));
        _cardImg.css('background-image', 'url(' + _cardImgUrl + ')');
    });

    $(window).resize(function () {
        _orderCount = calculateTotalOrder();

        if (_windowWidth >= 768) {
            closeAllResults();
        }
    });

    function closeCardResult () {
        $('.js-close-card').on('click', function () {
            var cardResult = $(this).closest('.card-result');
            cardResult.removeClass('active');
        });
    }

    function closeAllResults () {
        _cardsResults.removeClass('active').css('order', 'auto');
    }

    function calculateTotalOrder() {
        _windowWidth = $(window).width();

        if (_windowWidth >= 768) {
            return 3;
        } else {
            return 1;
        }
    }

    function calculateResultOrder(_currentCardOrder) {

        switch (_orderCount) {

            case 1 :
                return _currentCardOrder + 1;

            case 3 :
                for (var i = 0; i < 3; i++) {
                    if (_currentCardOrder % 3) {
                        _currentCardOrder++;
                    } else {
                        return _currentCardOrder + 1;
                    }
                }
                return _currentCardOrder + 1;

            case 4 :
                for (var j = 0; j < 4; j++) {
                    if (_currentCardOrder % 4) {
                        _currentCardOrder++;
                    } else {
                        return _currentCardOrder + 1;
                    }
                }
                return _currentCardOrder + 1;

            default :
                return _currentCardOrder + 1;
        }
    }

    function initCountTest() {
        if (_results.data('test')) {
            countTotal();
        }
    }
    
    function applyFilters() {
        closeAllResults();
        
        let checked = $('.js-availability:checked');
        let values = '';
        let ptVal = programType.val();
        let loVal = location.val();
        
        for (let i = 0; i < checked.length; i++) {
            values+= $(checked[i]).val();
            
            if (i + 1 !== checked.length) {
                values+= ',';
            }
        }
        
        if (!values && !ptVal && !loVal) {
            _cards.removeClass('hidden');
        } else if (!values && (ptVal || loVal)) {
            _cards.removeClass('hidden');
            $.each(_cards, function (i, item) {
                let check = true;
                if (ptVal && check) {
                    check = item.classList.contains(ptVal);
                }
                if (loVal && check) {
                    check = item.classList.contains(loVal);
                }
                
                $(item).toggleClass('hidden',!check);
            });
        } else {
            let valArray = values.split(',');
            $.each(_cards, function (i, item) {
                let check = false;
                
                for (let v = 0; v < valArray.length; v++) {
                    if (item.classList.contains(valArray[v])) {
                        check = true;
                        break;
                    }
                }
                
                if (ptVal && check) {
                    check = item.classList.contains(ptVal);
                }
                if (loVal && check) {
                    check = item.classList.contains(loVal);
                }
                
                $(item).toggleClass('hidden',!check);
            });
        }
        
        countTotal();
    }
    
    function chkAvailability() {
        _availability.on('change', applyFilters);
    }

    function searchFilter() {
        _search.addEventListener('keyup', function () {
            var filterRegex = new RegExp('\\b' + this.value, 'gi');
            _foundResult = 0;
            _foundCount = 1;
            closeAllResults();

            document.querySelectorAll('.js-pf-card').forEach(function (item) {
                var found = item.innerText.match(filterRegex);

                if (found) {

                    if (!item.classList.contains('choice-active') || (item.classList.contains('choice-active') && item.classList.contains('show-choice'))) {
                        _foundResult++;
                        item.style.order = _foundCount;
                        _foundCount++;
                    }
                }


                item.classList.toggle('hidden-search', !found);
            });

            if (!_foundResult) {
                _results.text('No results.');
            } else {
                var resText = ' Total Result';
                var suffix = _foundResult > 1 ? 's' : '';
                resText = resText + suffix;
                _results.text(_foundResult + resText);
            }
            
            applyFilters();
        });
    }

    function selectFilter(select) {
        select.on('change', applyFilters);
    }

    function iWantToFilter() {
        if (!_choices.length) {
            _cards.removeClass('choice-active show-choice');
            iWantTrigger.removeClass('fill');
        } else {
            _cards.addClass('choice-active').removeClass('show-choice');
            var filteredItems = $('.js-pf-card:not(.hidden-search)').filter('.' + _choices.join(', .'));
            filteredItems.addClass('show-choice');
            iWantTrigger.addClass('fill');
        }
    }

    function countTotal() {
        _foundResult = 0;
        _foundCount = 1;

        document.querySelectorAll('.js-pf-card:not(.hidden-search):not(.hidden)').forEach(function (item) {

            if (
                !item.classList.contains('choice-active')
                || (item.classList.contains('choice-active') && item.classList.contains('show-choice'))
            ) {
                _foundResult++;
                item.style.order = _foundCount;
                _foundCount++;
            }
        });

        if (!_foundResult) {
            _results.text('No results.');
        } else {
            var resText = ' Total Result';
            var suffix = _foundResult > 1 ? 's' : '';
            resText = resText + suffix;
            _results.text(_foundResult + resText);
        }
    }

    function iWantTo() {
        var _closeModal  = $('.js-close-modal');
        var _applyButton = $('#i-want-to-apply');

        if (!iWantTrigger.length)
            return;

        iWantTrigger.click(function () {
            _fancybox = new Fancybox([
                    {
                        src: '#i-want-to',
                        type: 'inline',
                    }
                ],
                {
                    on: {
                        "*": (event, fancybox, slide) => {
                            console.log(`event: ${event}`);
                        },
                        "Carousel.createSlide": (fancybox, carousel, slide) => {
                            console.log(slide.$el);
                        },
                        done: (fancybox, slide) => {
                            console.log(`done!`);
                        },
                    },
                }
            );
        });

        _closeModal.click(function () {
            _fancybox.close();
        });

        _applyButton.click(function () {
            closeAllResults();
            _choices = getIKnowChoices();
            iWantToFilter();
            countTotal();
            _fancybox.close();
        });
    }

    function getIKnowChoices() {
        return $('.js-i-want-to-choices:checked').map(function(_, el) {
            return $(el).val();
        }).get();
    }
};